import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '@/ui/_lib/Container';
import { useUser } from '@/contexts/UserContext/UserContext';
import ProfileTitle from '@/ui/components/complete-profile/ProfileTitle';

export default function ProfileTitlePage() {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user already has a title
    if (user?.title) {
      // Redirect to complete profile page
      navigate('/complete-profile');
    }
  }, [user, navigate]);

  // Don't render the form if user already has a title
  if (user?.title) {
    return null;
  }

  return (
    <Container className="flex h-full w-full items-center justify-center">
      <div className="flex w-full max-w-md flex-col gap-4">
        <ProfileTitle />
      </div>
    </Container>
  );
}